import React from 'react';

interface PoweredByProps {
  account: string;
  apiKey: string;
  // Localized template string containing the literal `{0}` token where the OMQ
  // wordmark link should appear. Example: 'Chatbot von {0}' or '{0} Chatbot'.
  template: string;
  // Localized "opens in new tab" hint (visually hidden) for the external link
  opensNewTabLabel?: string;
}

const buildTargetUrl = (account: string, apiKey: string): string =>
  'https://omq.ai/products/chatbot/' +
  '?utm_source=chat&utm_medium=product' +
  `&utm_campaign=${encodeURIComponent(account)}` +
  `&utm_content=${encodeURIComponent(apiKey)}`;

/**
 * Renders the "Chatbot von OMQ" tagline below the chatbot's input wrapper.
 * The template carries the localized text; only the `{0}` token becomes the
 * link to the OMQ product page, with account and apiKey embedded as UTM params.
 */
export const PoweredBy: React.FC<PoweredByProps> = ({
  account,
  apiKey,
  template,
  opensNewTabLabel,
}) => {
  const tokenIndex = template.indexOf('{0}');
  const before = tokenIndex >= 0 ? template.slice(0, tokenIndex) : template + ' ';
  const after = tokenIndex >= 0 ? template.slice(tokenIndex + '{0}'.length) : '';

  return (
    <div className="omq-chatbot-powered-by">
      {before && <span>{before}</span>}
      <a href={buildTargetUrl(account, apiKey)} target="_blank" rel="noopener noreferrer">
        OMQ
        <span className="omq-sr-only"> ({opensNewTabLabel || 'opens in new tab'})</span>
      </a>
      {after && <span>{after}</span>}
    </div>
  );
};
